var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"show"},[_c('b-card',[_c('div',[_vm._v(_vm._s(_vm.survey ? _vm.survey.name : ''))]),_vm._v(" "),(_vm.survey)?_c('survey',{attrs:{"data":_vm.survey.content},on:{"onComplete":_vm.onComplete}}):_vm._e()],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b471467","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/views/survey/show/show.html
// module id = null
// module chunks = 